import { render, staticRenderFns } from "./Form40Layout.vue?vue&type=template&id=27a737b6&scoped=true"
import script from "./Form40Layout.vue?vue&type=script&lang=ts"
export * from "./Form40Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=27a737b6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a737b6",
  null
  
)

export default component.exports